import {useApiSearchTeacherHomeworksReports} from "@/api/homework";
import TeacherLayout from "@/components/layout/teacher/teacherLayout";
import {URLS} from "@/lib/urls";
import RenderLoading from "@/components/render-if-loading";
import {Empty} from "antd";
import FreeBox from "@/components/box/freeBox";
import PaginationRaw from "@/components/pagination/PaginationRaw";
import {useState} from "react";
import {useSearchParams} from "react-router-dom";
import RenderIf from "@/components/render-if";
import HomeworkListItemComponent from "@/pages/teacher/homeworks/_section/HomeworkListItemComponent";

export default function TeacherHomeworksList() {

    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(15)
    const [search, setSearch] = useState()
    const [searchParams, setSearchParams] = useSearchParams();

    const {data: homeworksReports, isPending} = useApiSearchTeacherHomeworksReports({
        search: search, page: page, perPage: perPage,
        homework_id: searchParams.get('homework_id') ?? null,
    })


    return (

        <TeacherLayout pageTitle={'تکالیف ارسال شده'} backTo={URLS.teacher.dashboard}>

            {/*<SearchInputRaw setPage={setPage} setSearch={setSearch} />*/}
            <RenderLoading loading={isPending}>
                <FreeBox>
                    <RenderIf condition={homeworksReports?.data?.data?.length === 0}>
                        <Empty description={'هیچ تکلیفی ارسال نشده است'}/>
                    </RenderIf>

                    {homeworksReports?.data?.data.map((homeworkReport, i) => (
                        <HomeworkListItemComponent homeworkReport={homeworkReport}
                                                   key={'homework_' + homeworkReport?.id + '_' + i}/>
                    ))}
                    <PaginationRaw data={homeworksReports?.data} setPage={setPage} setPerPage={setPerPage}/>
                </FreeBox>
            </RenderLoading>
        </TeacherLayout>

    );
}